"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetGrowCycleSopsQuery = exports.useGetGrowCycleSopQuery = exports.growCycleSopApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var api_url_1 = require("../../utils/api-url");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.growCycleSopApi = (0, react_1.createApi)({
    reducerPath: "growCycleSopApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["grow-cycle-sop"],
    endpoints: function (builder) { return ({
        getGrowCycleSop: builder.query({
            query: function (id) { return "/v1/grow-cycle-sop/".concat(id); },
            providesTags: ["grow-cycle-sop"],
        }),
        getGrowCycleSops: builder.query({
            query: function (_a) {
                var growCycleId = _a.growCycleId, size = _a.size, pageNumber = _a.pageNumber, search = _a.search, sortBy = _a.sortBy, sortDirection = _a.sortDirection;
                return (0, api_url_1.appendUrlParams)("/v1/grow-cycle-sop", { grow_cycle_id: growCycleId, size: size, pageNumber: pageNumber, search: search, sortBy: sortBy, sortDirection: sortDirection });
            },
            providesTags: ["grow-cycle-sop"],
        }),
    }); },
});
exports.useGetGrowCycleSopQuery = exports.growCycleSopApi.useGetGrowCycleSopQuery, exports.useGetGrowCycleSopsQuery = exports.growCycleSopApi.useGetGrowCycleSopsQuery;
